<template>
	<div class="main-wrapper"> 
		<div id="particles-js"></div>
		<img :src="require('../assets/login-bg.jpg')" class="bg">


		 <div class="wrapper">
      <div id="form">
        <div class="logo">
          <img :src="require('../assets/logo.png')" >
        </div>
        
        <h4 class="text-center text-white">SET UP WALLET</h4>


        <div class="set-up-wallet" v-if="!isLoading" v-on:click="initImport">
            <img :src="require('../assets/existing.png')">
            <span>Import Existing Wallet</span>
        </div>

        <div class="set-up-wallet" v-on:click="generateWallet"  v-if="!successGenerate">
            <img v-if="!isLoading" :src="require('../assets/newwallet.png')">
            <span v-if="!isLoading">Create New Wallet</span>

            <div id="loading" v-if="isLoading">
              <div class="content"> 
                <span>Generating your wallet</span>
               	
                 <img :src="require('../assets/spinner.gif')" class="spinner">
              </div>
            </div>
        </div>
        

        <div class="set-up-wallet" v-if="successGenerate">
          <p class="text-center">Your wallet is successfully created.</p>
          <p class="text-center"> You will be redirected to the Dashboard in a few seconds.</p>
          
        </div>

      </div>
    </div>


    <ImportWallet v-if="init.show.importWallet" name="import-wallet" />
	 
	</div>
</template>

<script>

  import qs from 'querystring'
  import ImportWallet from '@/components/modal/ImportWallet.vue' 

	export default {
		name: 'SetupWallet',
		components: {
			ImportWallet
	    },
	   computed: {
	      	init() {
	        	return this.$store.state.init;
	      	},
	    },
		data: function() {
			return  {
				isLoading: false,
        isError: false,
        successGenerate: false
			}
		},
		methods: {

			initImport: function(){
        this.init.show.importWallet = true;
      },

      generateWallet: function(){
        this.isLoading = true;
        const options = {
          method: 'POST',
          headers: { 'content-type': 'application/x-www-form-urlencoded' },
          url: '/cx/cryptoaddress/BLX',
        };

        this.axios(options)
          .then((response) => {
              if(response.data.addressValue != undefined && response.data.addressValue != null && response.data.addressValue != '') {
 
                this.successGenerate = true;
                setTimeout(() => {
                  window.location.href = "/"; 
                },5000)
              } else {

              	setTimeout(() => {
                  this.generateWallet();
                },2000)


                
              }

            }).catch((err) => {
                
              console.log(err.response.data)     

              
            })
       
      },

			 checkSession: function() {

	        const options = {
	          method: 'POST',
	          headers: { 'content-type': 'application/x-www-form-urlencoded' },
	          url: '/cx/sessioncheck',
	        };

	        this.axios(options)
	          .then((response) => {

	              console.log(response)
	            }).catch((err) => {
	                
	              console.log(err.response.data)     

	              if(err.response.data.msgCode == '00001') {
	                window.location.href = "/#/login";
	              }  
	            })
	      },
		},
		beforeMount(){

				let particleScript = document.createElement('script')
      	particleScript.setAttribute('src', '/assets/js/particles.min.js')
      	document.head.appendChild(particleScript);

      	setTimeout(() => {
      		particlesJS.load('particles-js', '/assets/js/particles.json', function() {
					 
					});
      	},100)

      	this.checkSession();
	      
	    },
		watch: { 
	 
		}
	}
</script>

<style scoped lang="scss">

	.spinner {
		width: 50px !important;
		margin: 0 !important;
	}
  #loading {
    .content {
      display: flex;
    align-items: center;
    justify-content: center;
        flex-direction: column;
    }
  }
  .set-up-wallet {
    background: #2d2d2d;
    padding: 1em;
    margin-top: 1em;
    border-radius: 6px;
    cursor: pointer;
    color: #FFF;

    img {
      width: 25px;
      margin-right: 10px;
    }
  }
	#particles-js {
	        position: fixed;
		    width: 100%;
		    height: 100%;
		    top: 0;
		    left: 0;
		    z-index: 1;
	}

	.logo {
	    display:flex;
	    justify-content: center;
	    align-items: center;
	    margin-bottom: 1em;
	    img{
	      width: 50px;  
	    }
	    
	  } 

    .btn {
    	font-weight: bold;
    }

	.main-wrapper {
		display: flex;
	    justify-content: center;
	    height: 100vh;
	    flex-direction: column;
	    align-items: center;
	}

	.wrapper {
		padding: 2em;
    	background: #191919;
    	
	    display: flex;
	    flex-direction: column;
	    justify-content: space-evenly;
	    box-shadow: -1px 1px 20px 0px rgba(0,0,0,0.75);
		-webkit-box-shadow: -1px 1px 20px 0px rgba(0,0,0,0.75);
		-moz-box-shadow: -1px 1px 20px 0px rgba(0,0,0,0.75);
		width: 20em;
		    z-index: 2;
		form {
	      color: #FFF;
	    }
	}
	#lnkSignup {
		display:flex;
		align-items: center;
		justify-content: center;
		
		a {
			text-decoration: none;

			&:hover {
				text-decoration: underline;
			}
		}
	}

	 .footer {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #de8413; 
    bottom: 0.5em;
    width: 100%;
  }


	 @media(max-width: 39.9375em) {

	    .wrapper {
	      padding: 1em !important;
	      h4 {
	        font-size: 1.25em;
	      }

	      .email-or-mobile { 

	        .btn {
	          font-size: 1em;
	        }
	      }
	    }

	    button, input {
	      font-size: 85%;
	    }

	    .mobile-container {
	      .default-flag {
	        width: 25px;
	      }
	    }
	  }
</style>